import React from 'react';
export function IndividualServicesSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-t border-brand-gray-800" data-id="element-425">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-426">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-427">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-428">
            Private Investigation Services for Individuals, Individual Safety,
            Professional Protection and Security
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-429" />
        </div>

        <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed mb-12" data-id="element-430">
          <p className="text-center" data-id="element-431">
            Additional services we can provide can assist business travelers and
            high profile clients looking for extra protection and training
            services. Some of the additional services we provide are:
          </p>

          <ul className="space-y-4 mt-8 max-w-2xl mx-auto" data-id="element-432">
            {['Individual personal safety training and awareness training both in the workplace and at home', 'Situational self defense and understanding your use of force options as a civilian', 'Investigative Services: Providing some of the best surveillance and investigative practices in the world'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-433">
                <div className="w-1.5 h-1.5 bg-brand-teal flex-shrink-0 mt-2" data-id="element-434" />
                <span className="text-brand-gray-300 leading-relaxed" data-id="element-435">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="p-8 border-l-4 border-brand-teal bg-brand-black text-center max-w-2xl mx-auto mb-12" data-id="element-436">
          <p className="text-brand-white font-medium m-0 text-lg" data-id="element-437">
            Contact us for any questions you may have at:{' '}
            <a href="mailto:Info@apc360zone.com" className="text-brand-teal hover:text-brand-teal-light transition-colors font-bold" data-id="element-438">
              Info@apc360zone.com
            </a>{' '}
            or{' '}
            <a href="tel:18666343373" className="text-brand-teal hover:text-brand-teal-light transition-colors font-bold" data-id="element-439">
              1-866-634-3373
            </a>
          </p>
        </div>

        <p className="text-center text-brand-gray-400 font-bold tracking-wide uppercase text-sm" data-id="element-440">
          **PLEASE NOTE: We are a licensed NJ Private Investigations Company**
        </p>
      </div>
    </section>;
}